module.exports = __webpack_public_path__ + "img/svg/background-ranked-classification-mobile.fc6437a38ca87b4d9f6e77d0dbde8db7.svg";